import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asignar-graduaciones',
  templateUrl: './asignar-graduaciones.component.html',
  styleUrls: ['./asignar-graduaciones.component.css']
})
export class AsignarGraduacionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
